import { Link } from "react-router-dom";



const Homex = () => {
  return (
    <main className="homex">
      <section className="herox">
        <div className="herox-container">

          {/* CONTENIDO */}
          <div className="herox-content">

            <span className="herox-tag">
              OPTIMIZACIÓN DE PROCESOS
            </span>

            <h1>
              ¿Cuánto tiempo pierde tu empresa
              <span> trabajando con datos desordenados?</span>
            </h1>

            <p className="herox-description">
              Ordeno Excel, productos, imágenes y procesos
              para reducir tareas manuales y ayudarte a
              <strong> recuperar tiempo.</strong>
            </p>

          <Link to="/analisis" className="herox-button">
  TEST GRATUITO DE MI PROCESO
  <span>→</span>
</Link>

            <div className="herox-trust">
              <span>✓ Menos tareas manuales</span>
              <span>✓ Datos organizados</span>
              <span>✓ Más tiempo para tu negocio</span>
            </div>

          </div>

          {/* VISUAL */}
          <div className="herox-visual">

            <div className="dashboardx">

              <div className="dashboardx-header">
                <div>
                  <span className="dashboardx-label">
                    PROCESO ACTUAL
                  </span>

                  <h3>
                    Gestión de productos
                  </h3>
                </div>

                <span className="status">
                  ● OPTIMIZADO
                </span>
              </div>

              <div className="data-list">

                <div className="data-row">
                  <div className="data-icon excel">
                    XLS
                  </div>

                  <div className="data-info">
                    <strong>Base de productos</strong>
                    <span>Excel → Base de datos</span>
                  </div>

                  <span className="check">✓</span>
                </div>

                <div className="data-row">
                  <div className="data-icon image">
                    IMG
                  </div>

                  <div className="data-info">
                    <strong>Imágenes</strong>
                    <span>Organización automática</span>
                  </div>

                  <span className="check">✓</span>
                </div>

                <div className="data-row">
                  <div className="data-icon process">
                    ⚙
                  </div>

                  <div className="data-info">
                    <strong>Tareas manuales</strong>
                    <span>Procesos automatizados</span>
                  </div>

                  <span className="check">✓</span>
                </div>

              </div>

              <div className="dashboard-footer">
                <div>
                  <span>Tiempo recuperado</span>
                  <strong>12 hs / semana</strong>
                </div>

                <div className="progress">
                  <div></div>
                </div>
              </div>

            </div>

            <div className="floating-stat">
              <span>↓</span>

              <div>
                <small>TAREAS MANUALES</small>
                <strong>-68%</strong>
              </div>
            </div>

          </div>
   <a href="#analizar" className="herox-button-cel">
          QUIERO ANALIZAR MI PROCESO
              <span>→</span>
            </a>
        </div>
      </section>
    </main>
  );
};

export default Homex;
